module.exports = __webpack_public_path__ + "media/images/icons/icon_loading-8cc8149fcf3606cb4df4d56e12843136.svg";